
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/revision/[id]",
      function () {
        return require("private-next-pages/revision/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/revision/[id]"])
      });
    }
  